<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>B端账户注册</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="prompt_style">*此操作会更新用户信息和订阅信息！仅供B端免费账户使用。</div>
        <div class="box_style">
            <el-form :model="apiData" :rules="rules" ref="apiData" label-width="100px" size="medium">
                <el-form-item label="手机号" prop="mobile">
                    <el-input style="width: 200px;" v-model="apiData.mobile" placeholder="请输入手机号" max="11"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="会员等级" prop="vip_level_id">
                    <el-select v-model="apiData.vip_level_id" placeholder="请选择会员等级">
                        <el-option v-for="item in vipLevels" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input style="width: 200px;" v-model="apiData.note" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('apiData')">立即注册</el-button>
                    <el-button @click="resetForm('apiData')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            vipLevels: [
                { value: 21, label: 'vip体验' },
                { value: 22, label: 'vip季度' },
                { value: 23, label: 'vip年度' },
                { value: 31, label: 'Svip体验' },
                { value: 32, label: 'Svip季度' },
                { value: 33, label: 'Svip年度' },
            ],
            apiData: {
                mobile: '',
                vip_level_id: null,
                duration_days: 0,
                note: ''
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^[1][3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                vip_level_id: [
                    { required: true, message: '请选择会员等级', trigger: 'change' },
                ],
            }
        }
    },
    methods: {
        clickSubmit() {
            const vipLevelToDurationDays = {
                21: 7,
                22: 90,
                23: 365,
                31: 7,
                32: 90,
                33: 365
            };
            if (vipLevelToDurationDays.hasOwnProperty(this.apiData.vip_level_id)) {
                this.apiData.duration_days = vipLevelToDurationDays[this.apiData.vip_level_id];
            }
            console.log(this.apiData,'传参')
            this.$post('/v1/B-free-sign-up', this.apiData).then((res) => {
                if (res.data.resid === 200) {
                    this.$message.success('注册成功')
                    this.apiData.duration_days = 0
                    this.apiData.note = ''
                    this.resetForm('apiData');
                    console.log(res, this.apiData)
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.apiData,'==========')
                    this.clickSubmit()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  </style>
<style scoped>
.box_style {
    margin-top: 20px;
}

.prompt_style {
    margin-top: 20px;
    padding: 10px;
    font-size: 20px;
    background-color: #F56C6C;
    border-radius: 5px;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/BAccountRegistration/BAccountRegistration.vue